import { cn } from "@/lib/utils";

const STAGE_TONE = {
  "New Lead": "blue",
  Contacted: "blue",
  "Fact Find Complete": "indigo",
  "Ready to Quote": "indigo",
  Quoted: "violet",
  "Application Started": "violet",
  "Application Submitted": "amber",
  "Pending Underwriting": "amber",
  "Approved as Quoted": "green",
  "Approved - Higher Premium": "green",
  "Approved - Lower Face Amount": "green",
  "Declined - Requote Needed": "red",
  "Issued / Active": "emerald",
  "Follow-Up Due": "amber",
  "Client Declined": "red",
  "Closed Lost": "slate",
};

const KEYWORD_TONE = [
  [/approved/i, "green"],
  [/active|resolved|accepted|match found|paid/i, "emerald"],
  [/declined|red|lapse|no match|cancelled/i, "red"],
  [/pending|delayed|review|orange|started|payment/i, "amber"],
  [/none/i, "slate"],
];

const TONE_CLASS = {
  blue: "bg-[#315A7D]/10 text-[#2c5170] ring-[#315A7D]/25",
  indigo: "bg-[#17324D]/10 text-[#17324D] ring-[#17324D]/20",
  violet: "bg-[#B28A3D]/12 text-[#7a5d27] ring-[#B28A3D]/30",
  amber: "bg-amber-50 text-amber-700 ring-amber-200",
  green: "bg-green-50 text-green-700 ring-green-200",
  emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  red: "bg-red-50 text-red-700 ring-red-200",
  slate: "bg-slate-100 text-slate-600 ring-slate-200",
};

function toneFor(value) {
  if (!value) return "slate";
  if (STAGE_TONE[value]) return STAGE_TONE[value];
  for (const [re, tone] of KEYWORD_TONE) if (re.test(value)) return tone;
  return "slate";
}

export function StatusBadge({ value, className }) {
  if (!value) return <span className="text-muted-foreground">—</span>;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset whitespace-nowrap",
        TONE_CLASS[toneFor(value)],
        className
      )}
    >
      {value}
    </span>
  );
}

const RATING_MAP = {
  green: { dot: "bg-emerald-500", label: "Preferred", cls: "bg-emerald-50 text-emerald-700 ring-emerald-200" },
  orange: { dot: "bg-amber-500", label: "Testing", cls: "bg-amber-50 text-amber-700 ring-amber-200" },
  red: { dot: "bg-red-500", label: "Avoid", cls: "bg-red-50 text-red-700 ring-red-200" },
};

export function RatingBadge({ value }) {
  const r = RATING_MAP[value] || RATING_MAP.orange;
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset", r.cls)}>
      <span className={cn("h-2 w-2 rounded-full", r.dot)} />
      {r.label}
    </span>
  );
}
